// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_accounts_view from "./web_accounts_view.js";
import * as Mapre_web__Web_build_view from "./web_build_view.js";
import * as Mapre_web__Web_environment_view from "./web_environment_view.js";
import * as Mapre_web__Web_graph_view from "./web_graph_view.js";
import * as Mapre_web__Web_invitation_view from "./web_invitation_view.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_personal_tokens_view from "./web_personal_tokens_view.js";
import * as Mapre_web__Web_project_view from "./web_project_view.js";
import * as Mapre_web__Web_pulls_view from "./web_pulls_view.js";
import * as Mapre_web__Web_settings_view from "./web_settings_view.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Mapre_web__Web_usage_view from "./web_usage_view.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

const items_0 = {
  id: "general",
  title: "General",
  icon: "settings",
  needs_project: false,
  open_action: {
    TAG: /* Settings */ 37,
    _0: {
      TAG: /* Open */ 0,
      _0: ""
    }
  },
  enabled: (function (m) {
    return Mapre_web__Web_types.workspace(m.route) !== undefined;
  })
};

const items_1 = {
  hd: {
    id: "usage",
    title: "Usage",
    icon: "file-text",
    needs_project: false,
    open_action: {
      TAG: /* Usage */ 38,
      _0: /* Open */ 0
    },
    enabled: (function (m) {
      return Mapre_web__Web_types.workspace(m.route) !== undefined;
    })
  },
  tl: {
    hd: {
      id: "accounts",
      title: "Accounts",
      icon: "user",
      needs_project: false,
      open_action: {
        TAG: /* Accounts */ 41,
        _0: {
          TAG: /* Open */ 0,
          _0: ""
        }
      },
      enabled: (function (m) {
        return m.current_user !== undefined;
      })
    },
    tl: {
      hd: {
        id: "members",
        title: "Members",
        icon: "users",
        needs_project: false,
        open_action: {
          TAG: /* Invitations */ 48,
          _0: {
            TAG: /* Open */ 0,
            _0: ""
          }
        },
        enabled: Mapre_web__Web_model.can_manage_members
      },
      tl: {
        hd: {
          id: "project",
          title: "Project",
          icon: "folder",
          needs_project: true,
          open_action: {
            TAG: /* Project_setup */ 32,
            _0: {
              TAG: /* Open */ 0,
              _0: ""
            }
          },
          enabled: Mapre_web__Web_model.can_manage_project
        },
        tl: {
          hd: {
            id: "environment",
            title: "Environment",
            icon: "terminal",
            needs_project: true,
            open_action: {
              TAG: /* Environment */ 33,
              _0: {
                TAG: /* Open */ 0,
                _0: ""
              }
            },
            enabled: Mapre_web__Web_model.can_edit_environment
          },
          tl: {
            hd: {
              id: "templates",
              title: "Templates",
              icon: "archive",
              needs_project: true,
              open_action: {
                TAG: /* Build */ 34,
                _0: {
                  TAG: /* Open */ 0,
                  _0: ""
                }
              },
              enabled: Mapre_web__Web_model.can_edit_environment
            },
            tl: {
              hd: {
                id: "pulls",
                title: "Pull requests",
                icon: "git-pull-request",
                needs_project: true,
                open_action: {
                  TAG: /* Pulls */ 35,
                  _0: {
                    TAG: /* Open */ 0,
                    _0: ""
                  }
                },
                enabled: Mapre_web__Web_model.can_edit_environment
              },
              tl: {
                hd: {
                  id: "logseq",
                  title: "Logseq",
                  icon: "file-text",
                  needs_project: false,
                  open_action: {
                    TAG: /* Graph */ 36,
                    _0: {
                      TAG: /* Open */ 0,
                      _0: ""
                    }
                  },
                  enabled: (function (m) {
                    return Mapre_web__Web_types.workspace(m.route) !== undefined;
                  })
                },
                tl: /* [] */ 0
              }
            }
          }
        }
      }
    }
  }
};

const items = {
  hd: items_0,
  tl: items_1
};

function title_of(param) {
  switch (param) {
    case "accounts" :
      return "Accounts";
    case "environment" :
      return "Environment";
    case "general" :
      return "General";
    case "logseq" :
      return "Logseq";
    case "members" :
      return "Members";
    case "project" :
      return "Project";
    case "pulls" :
      return "Pull requests";
    case "templates" :
      return "Templates";
    case "usage" :
      return "Usage";
    default:
      return "Settings";
  }
}

function nav_item(send, model, item) {
  const partial_arg = item.title;
  const partial_arg$1 = "nav-label";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$2 = {
    hd: partial_arg_0,
    tl: /* [] */ 0
  };
  const partial_arg$3 = (function (param) {
    let model$1 = Signal.sample(model);
    if (!Curry._1(item.enabled, model$1)) {
      return;
    }
    if (Caml_obj.caml_equal(Mapre_web__Web_model.pane(model$1), item.id)) {
      if (model$1.compact && model$1.navigation_open) {
        Curry._1(send, /* Toggle_navigation */ 7);
        return;
      } else {
        return;
      }
    }
    if (item.needs_project && Mapre_web__Web_types.project(model$1.route) === undefined) {
      const match = model$1.projects;
      if (match) {
        const w = Mapre_web__Web_types.workspace(model$1.route);
        if (w !== undefined) {
          Curry._1(send, {
            TAG: /* Navigate */ 0,
            _0: {
              TAG: /* Project */ 2,
              _0: w,
              _1: match.hd.id
            }
          });
          Curry._1(send, item.open_action);
          return;
        } else {
          return;
        }
      }
      Curry._1(send, item.open_action);
      return;
    }
    Curry._1(send, item.open_action);
  });
  const partial_arg$4 = item.title;
  const partial_arg$5 = {
    NAME: "app",
    VAL: item.icon
  };
  const partial_arg$6 = "ghost";
  const partial_arg$7 = Caml_option.some(Signal.map((function (m) {
    if (Caml_obj.caml_equal(Mapre_web__Web_model.pane(m), item.id)) {
      return {
        hd: [
          "aria-current",
          "true"
        ],
        tl: /* [] */ 0
      };
    } else {
      return /* [] */ 0;
    }
  }), model));
  const partial_arg$8 = "nav-item";
  return function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, partial_arg$5, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, param, param$1);
  };
}

function nav_visible(m) {
  if (m.compact) {
    return m.navigation_open;
  } else {
    return true;
  }
}

function nav_pane(send, source) {
  return function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___001_) {
      const partial_arg = "Settings";
      const partial_arg$1 = 1;
      const partial_arg$2 = "settings-title";
      const partial_arg$3 = (function (param) {
        return Lui_elements.press(send, /* Close_settings */ 17, param);
      });
      const partial_arg$4 = "Close settings";
      const partial_arg$5 = {
        NAME: "app",
        VAL: "x"
      };
      const partial_arg$6 = "icon";
      const partial_arg$7 = "ghost";
      const partial_arg_0 = function (param, param$1) {
        return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
      const partial_arg_1 = {
        hd: (function (param, param$1) {
          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, partial_arg$6, partial_arg$5, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        }),
        tl: /* [] */ 0
      };
      const partial_arg$8 = {
        hd: partial_arg_0,
        tl: partial_arg_1
      };
      const partial_arg$9 = "center";
      const partial_arg$10 = "space_between";
      const partial_arg$11 = "Workspace";
      const partial_arg$12 = "nav-eyebrow";
      const partial_arg$13 = Stdlib__List.map((function (item) {
        const partial_arg = nav_item(send, source, item);
        const partial_arg$1 = Signal.map((function (m) {
          return Curry._1(item.enabled, m);
        }), source);
        return function (param, param$1) {
          return Lui_elements.if_(partial_arg$1, partial_arg, param, param$1);
        };
      }), items);
      const partial_arg$14 = 0;
      const partial_arg$15 = 2;
      const partial_arg_0$1 = function (param, param$1) {
        return Lui_elements.column(undefined, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, param, param$1);
      };
      const partial_arg$16 = {
        hd: partial_arg_0$1,
        tl: /* [] */ 0
      };
      const partial_arg$17 = 0;
      const partial_arg$18 = 1;
      const partial_arg_0$2 = function (param, param$1) {
        return Lui_elements.row(undefined, undefined, partial_arg$10, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, param, param$1);
      };
      const partial_arg_1$1 = {
        hd: (function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.scroll(undefined, undefined, undefined, undefined, partial_arg$18, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$17, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$16, param, param$1);
          }),
          tl: /* [] */ 0
        }
      };
      const partial_arg$19 = {
        hd: partial_arg_0$2,
        tl: partial_arg_1$1
      };
      const partial_arg$20 = "sidepane settings-nav";
      const partial_arg$21 = 0;
      const partial_arg$22 = 288;
      const partial_arg$23 = 16;
      const partial_arg$24 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (m) {
        if (m.compact) {
          return 1;
        } else {
          return 0;
        }
      }), source)));
      const partial_arg$25 = 4;
      return function (param, param$1) {
        return Lui_elements.column(undefined, partial_arg$25, undefined, undefined, undefined, partial_arg$24, undefined, partial_arg$23, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$22, undefined, partial_arg$21, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$20, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$19, param, param$1);
      };
    }), param, param$1);
  };
}

function compact_header(send, source) {
  const partial_arg = (function (param) {
    return Lui_elements.press(send, /* Toggle_navigation */ 7, param);
  });
  const partial_arg$1 = "Settings navigation";
  const partial_arg$2 = {
    NAME: "app",
    VAL: "panel-left"
  };
  const partial_arg$3 = "icon";
  const partial_arg$4 = "ghost";
  const partial_arg$5 = (function (param) {
    return Lui_elements.press(send, /* Close_settings */ 17, param);
  });
  const partial_arg$6 = "Close settings";
  const partial_arg$7 = {
    NAME: "app",
    VAL: "x"
  };
  const partial_arg$8 = "icon";
  const partial_arg$9 = "ghost";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, partial_arg$2, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, partial_arg$8, partial_arg$7, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$10 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$11 = 8;
  const partial_arg$12 = "center";
  const partial_arg$13 = "space_between";
  const partial_arg$14 = function (param, param$1) {
    return Lui_elements.row(undefined, undefined, partial_arg$13, partial_arg$12, undefined, undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, param, param$1);
  };
  const partial_arg$15 = Signal.map((function (m) {
    return m.compact;
  }), source);
  return function (param, param$1) {
    return Lui_elements.if_(partial_arg$15, partial_arg$14, param, param$1);
  };
}

function content_body(send, source) {
  const partial_arg = Signal.map((function (m) {
    return m.notice !== "";
  }), source);
  const partial_arg$1 = Signal.map(Mapre_web__Web_model.pane, source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___002_) {
      const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (m) {
        return Stdlib__Option.fold("Settings", title_of, Mapre_web__Web_model.pane(m));
      }), source)));
      const partial_arg$1 = 1;
      const partial_arg$2 = "pane-title";
      return function (param, param$1) {
        return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg, (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___003_) {
          const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (m) {
            return m.notice;
          }), source)));
          const partial_arg$1 = "notice";
          return function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.dyn(undefined, (function (id) {
          if (id !== undefined) {
            switch (id) {
              case "accounts" :
                return Mapre_web__Web_accounts_view.view(source, send);
              case "environment" :
                return Mapre_web__Web_environment_view.view(source, send);
              case "general" :
                const partial_arg = Mapre_web__Web_personal_tokens_view.view(source, send);
                const partial_arg$1 = Signal.map((function (m) {
                  return m.personal_tokens !== undefined;
                }), source);
                const partial_arg_0 = Mapre_web__Web_settings_view.view(source, send);
                const partial_arg_1 = {
                  hd: (function (param, param$1) {
                    return Lui_elements.if_(partial_arg$1, partial_arg, param, param$1);
                  }),
                  tl: /* [] */ 0
                };
                const partial_arg$2 = {
                  hd: partial_arg_0,
                  tl: partial_arg_1
                };
                const partial_arg$3 = 0;
                const partial_arg$4 = 16;
                return function (param, param$1) {
                  return Lui_elements.column(undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, param, param$1);
                };
              case "logseq" :
                return Mapre_web__Web_graph_view.view(source, send);
              case "members" :
                return Mapre_web__Web_invitation_view.view(source, send);
              case "project" :
                return Mapre_web__Web_project_view.view(source, send);
              case "pulls" :
                return Mapre_web__Web_pulls_view.view(source, send);
              case "templates" :
                return Mapre_web__Web_build_view.view(source, send);
              case "usage" :
                return Mapre_web__Web_usage_view.view(source, send);
              default:
                return function (param, param$1) {
                  return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                };
            }
          } else {
            return function (param, param$1) {
              return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }
        }), partial_arg$1, param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$2 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$3 = "settings-main";
  const partial_arg$4 = 728;
  const partial_arg$5 = 0;
  const partial_arg$6 = 24;
  const partial_arg$7 = 1;
  const partial_arg$8 = 16;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$8, undefined, undefined, partial_arg$7, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, param, param$1);
  };
  const partial_arg$9 = {
    hd: partial_arg_0$1,
    tl: /* [] */ 0
  };
  const partial_arg$10 = 0;
  const partial_arg$11 = "center";
  const partial_arg_0$2 = function (param, param$1) {
    return Lui_elements.row(undefined, undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, param, param$1);
  };
  const partial_arg$12 = {
    hd: partial_arg_0$2,
    tl: /* [] */ 0
  };
  const partial_arg$13 = "settings-scroll";
  const partial_arg$14 = 0;
  const partial_arg$15 = 0;
  const partial_arg$16 = 1;
  return function (param, param$1) {
    return Lui_elements.scroll(undefined, undefined, undefined, undefined, partial_arg$16, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$15, undefined, partial_arg$14, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, param, param$1);
  };
}

function content(send, source) {
  return function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___004_) {
      const partial_arg_0 = compact_header(send, source);
      const partial_arg_1 = {
        hd: content_body(send, source),
        tl: /* [] */ 0
      };
      const partial_arg = {
        hd: partial_arg_0,
        tl: partial_arg_1
      };
      const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (m) {
        if (m.compact && m.navigation_open) {
          return "none";
        } else {
          return "inline_flex";
        }
      }), source)));
      const partial_arg$2 = 0;
      const partial_arg$3 = 0;
      const partial_arg$4 = 1;
      return function (param, param$1) {
        return Lui_elements.column(undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, partial_arg, param, param$1);
      };
    }), param, param$1);
  };
}

export {
  nav_visible,
  nav_pane,
  content,
}
/* Lui_elements Not a pure module */
